module.exports = __webpack_public_path__ + "static/media/at-image.dd9bdb09.jpg";